export default {"src":"/_next/static/media/user-dark.bc71258b.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};